/**
 * @file OrderStagePill.tsx
 * @description Пилюля стадии заказа (phase19.31, зона «Заказы»; SC26–SC28).
 *
 * Одна форма в реестре, на доске и в шапке карточки: фон и текст — тон по
 * ВИДУ стадии (`orderStageView`), а цвет, который задал магазин, — только
 * точкой. Точку рисует тема (`::before` у пилюли), здесь лишь подменяем её
 * цвет переменной `--badge-dot`: так тон остаётся читаемым при любом цвете
 * магазина, а метка магазина узнаваема.
 */

import type { CSSProperties } from "react";

import { Badge } from "../ui/badge";
import type { OrderDto } from "../../lib/api-orders";
import { orderStageView } from "../../lib/order-registry-cells";
import { STATUS_TONE_VARIANT } from "../../lib/shop/status-meta";
import { cn } from "@/lib/utils";

interface Props {
  order: Pick<OrderDto, "stage" | "status">;
  className?: string;
}

export function OrderStagePill({ order, className }: Props) {
  const view = orderStageView(order);
  // Точка цвета магазина — через переменную темы, текст и фон не трогаем.
  const style = view.color ? ({ "--badge-dot": view.color } as CSSProperties) : undefined;
  return (
    <Badge
      variant={STATUS_TONE_VARIANT[view.tone]}
      data-status-tone={view.tone}
      style={style}
      title={view.label}
      className={cn("max-w-full min-w-0", className)}
    >
      <span className="truncate">{view.label}</span>
    </Badge>
  );
}
